<template>
  <v-row>
    <v-col cols="12" lg="9" class="pa-2 pb-0">
      <h3 class="h3">Totales</h3>
    </v-col>

    <v-col v-if="gestion?.numero == '2023'" cols="12" lg="3" class="pa-2 pb-0">
      <v-switch class="ml-4" v-model="seSumaraIngresosPendientes" label="Sumar Ingresos Pendientes"></v-switch>
    </v-col>

    <v-col cols="12" class="pa-2 pb-0">
      <v-simple-table dense style="border: 1px solid #d1d1d1">
        <thead>
          <tr>
            <th class="text-left caption">#</th>
            <th class="text-left caption">NOMBRE</th>
            <th class="text-right caption">ENERO</th>
            <th class="text-right caption">FEBRERO</th>
            <th class="text-right caption">MARZO</th>
            <th class="text-right caption">ABRIL</th>
            <th class="text-right caption">MAYO</th>
            <th class="text-right caption">JUNIO</th>
            <th class="text-right caption">JULIO</th>
            <th class="text-right caption">AGOSTO</th>
            <th class="text-right caption">SEPTIEMBRE</th>
            <th class="text-right caption">OCTUBRE</th>
            <th class="text-right caption">NOVIEMBRE</th>
            <th class="text-right caption">DICIEMBRE</th>
            <th class="text-right caption">TOTAL</th>
          </tr>
        </thead>

        <tbody>
          <template v-if="gestion?.numero == '2023'">
            <tr v-if="seSumaraIngresosPendientes">
              <td class="text-left caption">1</td>
              <td class="text-left caption">
                Ingresos Estimados <v-chip class="ma-2" outlined x-small color="orange"> Pendiente</v-chip>
              </td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.enero) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.febrero) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.marzo) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.abril) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.mayo) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.junio) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.julio) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.agosto) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.septiembre) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.octubre) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.noviembre) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.diciembre) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosGestionTotales.total) }}</td>
            </tr>

            <tr>
              <td class="text-left caption">1</td>
              <td class="text-left caption">
                Ingresos Estimados <v-chip class="ma-2" outlined x-small color="success"> Aceptado</v-chip>
              </td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.enero) }}</td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.febrero) }}
              </td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.marzo) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.abril) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.mayo) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.junio) }}</td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.julio) }}</td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.agosto) }}
              </td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.septiembre) }}
              </td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.octubre) }}
              </td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.noviembre) }}
              </td>
              <td class="text-right caption">
                {{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.diciembre) }}
              </td>
              <td class="text-right caption">{{ formatearNumero(ingresosEstimadosAceptadosGestionTotales.total) }}</td>
            </tr>
          </template>

          <tr>
            <td class="text-left caption">2</td>
            <td class="text-left caption">Ingresos Proyectados</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.enero) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.febrero) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.marzo) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.abril) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.mayo) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.junio) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.julio) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.agosto) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.septiembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.octubre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.noviembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.diciembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosProyectadosGestionTotales.total) }}</td>
          </tr>

          <tr>
            <td class="text-left caption">3</td>
            <td class="text-left caption">Ingresos</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.enero) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.febrero) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.marzo) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.abril) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.mayo) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.junio) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.julio) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.agosto) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.septiembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.octubre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.noviembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.diciembre) }}</td>
            <td class="text-right caption">{{ formatearNumero(ingresosOtrosGestionTotales.total) }}</td>
          </tr>

          <tr>
            <td class="text-left caption"></td>
            <td class="text-left caption">Total</td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.enero : 0) +
                    ingresosEstimadosAceptadosGestionTotales.enero +
                    ingresosProyectadosGestionTotales.enero +
                    ingresosOtrosGestionTotales.enero,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.febrero : 0) +
                    ingresosEstimadosAceptadosGestionTotales.febrero +
                    ingresosProyectadosGestionTotales.febrero +
                    ingresosOtrosGestionTotales.febrero,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.marzo : 0) +
                    ingresosEstimadosAceptadosGestionTotales.marzo +
                    ingresosProyectadosGestionTotales.marzo +
                    ingresosOtrosGestionTotales.marzo,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.abril : 0) +
                    ingresosEstimadosAceptadosGestionTotales.abril +
                    ingresosProyectadosGestionTotales.abril +
                    ingresosOtrosGestionTotales.abril,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.mayo : 0) +
                    ingresosEstimadosAceptadosGestionTotales.mayo +
                    ingresosProyectadosGestionTotales.mayo +
                    ingresosOtrosGestionTotales.mayo,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.junio : 0) +
                    ingresosEstimadosAceptadosGestionTotales.junio +
                    ingresosProyectadosGestionTotales.junio +
                    ingresosOtrosGestionTotales.junio,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.julio : 0) +
                    ingresosEstimadosAceptadosGestionTotales.julio +
                    ingresosProyectadosGestionTotales.julio +
                    ingresosOtrosGestionTotales.julio,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.agosto : 0) +
                    ingresosEstimadosAceptadosGestionTotales.agosto +
                    ingresosProyectadosGestionTotales.agosto +
                    ingresosOtrosGestionTotales.agosto,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.septiembre : 0) +
                    ingresosEstimadosAceptadosGestionTotales.septiembre +
                    ingresosProyectadosGestionTotales.septiembre +
                    ingresosOtrosGestionTotales.septiembre,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.octubre : 0) +
                    ingresosEstimadosAceptadosGestionTotales.octubre +
                    ingresosProyectadosGestionTotales.octubre +
                    ingresosOtrosGestionTotales.octubre,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.noviembre : 0) +
                    ingresosEstimadosAceptadosGestionTotales.noviembre +
                    ingresosProyectadosGestionTotales.noviembre +
                    ingresosOtrosGestionTotales.noviembre,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.diciembre : 0) +
                    ingresosEstimadosAceptadosGestionTotales.diciembre +
                    ingresosProyectadosGestionTotales.diciembre +
                    ingresosOtrosGestionTotales.diciembre,
                )
              }}
            </td>
            <td class="text-right caption">
              {{
                formatearNumero(
                  (seSumaraIngresosPendientes ? ingresosEstimadosGestionTotales.total : 0) +
                    ingresosEstimadosAceptadosGestionTotales.total +
                    ingresosProyectadosGestionTotales.total +
                    ingresosOtrosGestionTotales.total,
                )
              }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import { validacionDeCampos, formatearNumero } from '../../utils';

export default {
  name: 'ReporteIngresosTotales',
  props: {
    ingresosEstimadosGestionTotales: {
      type: Object,
      validator: validacionDeCampos,
    },
    ingresosEstimadosAceptadosGestionTotales: {
      type: Object,
      validator: validacionDeCampos,
    },
    ingresosProyectadosGestionTotales: {
      type: Object,
      validator: validacionDeCampos,
    },
    ingresosOtrosGestionTotales: {
      type: Object,
      validator: validacionDeCampos,
    },
    gestion: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      seSumaraIngresosPendientes: false,
    };
  },
  methods: {
    formatearNumero,
  },
};
</script>